import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { SalaryDeviationReportChildrenBaseProps } from "models/propTypes/salaryDeviationPropTypes";
import { SalaryDeviationFormTypes } from "models/formTypes";
//#endregion
//#region components
import { MoreActionsButton, useFilterContext } from "components/common";
import useCreateAllowanceDialog from "./forms/useCreateAllowanceDialog";
import useCreateLeaveDialog from "./forms/useCreateLeaveDialog";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";

const CreateDeviationsButton: React.FC<SalaryDeviationReportChildrenBaseProps> = (props) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const { reloadList } = props;
  const { filter } = useFilterContext<SalaryDeviationFormTypes.Filter>();

  const openLeaveDialog = useCreateLeaveDialog(reloadList);

  const openAllowanceDialog = useCreateAllowanceDialog(reloadList);

  const filterMonth = React.useMemo(() => {
    return DateHelper.getYearMonth(filter?.yearAndMonth ?? new Date());
  }, [filter?.yearAndMonth]);

  const onOpenLeaveDialogClick = () => {
    dispatch(displayDialog(openLeaveDialog({ yearMonth: filterMonth })));
  };

  return (
    <MoreActionsButton
      size="sm"
      menuItems={[
        {
          description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.CreateAllowance),
          actionDialog: openAllowanceDialog({ yearMonth: filterMonth }),
          icon: IconDefinitionConstants.WMoney,
        },
      ]}
      onClick={onOpenLeaveDialogClick}
      menuPlacement="bottom"
    >
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.AddDeviation)}
    </MoreActionsButton>
  );
};

export default CreateDeviationsButton;
